import { Component, OnInit } from '@angular/core';
import { ModalContainerService, BaseModalUpdateComponent, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { VrstaKomitenta } from './vrsta-komitenta';

@Component({
  selector: 'yt-vrsta-komitenta-modal-update',
  templateUrl: './vrsta-komitenta-modal-update.component.html'
})
export class VrstaKomitentaModalUpdateComponent extends BaseModalUpdateComponent<VrstaKomitenta> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VrstaKomitenta>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }
  ngOnInit() {
  }

}
